export default "__VITE_ASSET__327e73e2__"